import { render, staticRenderFns } from "./VNotificationsTemplate.vue?vue&type=template&id=3e4e5be4&scoped=true&lang=pug"
import script from "./VNotificationsTemplate.vue?vue&type=script&lang=ts"
export * from "./VNotificationsTemplate.vue?vue&type=script&lang=ts"
import style0 from "./VNotificationsTemplate.vue?vue&type=style&index=0&id=3e4e5be4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4e5be4",
  null
  
)

export default component.exports